<template>
    <el-dialog title="绑定支付宝" :visible="visible" class="form-drawer" center :append-to-body="true" :wrapper-closable="false"
        direction="rtl" width="550px" @update:visible="onCancel">
        <div class="form-drawer-content">
            <el-form ref="formData" class="label-left" :model="formData" :rules="rules" label-width="140px">
                <div class="describe">
                    认证是为了确保收款的支付宝账号的持有人为（
                    <b>{{ $store.state.userInfo ? $store.state.userInfo.name : '' }}</b>
                    ）授权合同的签约人
                    <br />
                    认证前，请确认您的支付宝账号通过了实名认证
                </div>
                <el-form-item prop="address">
                    <template slot="label">支付宝账号</template>
                    <el-input type="text" placeholder="请输入支付宝账号" v-model="formData.address"></el-input>
                    <p class="color-base">认证完成后，不可自行更改支付宝账号</p>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onCancel">取消</el-button>
                    <el-button type="primary" :loading="loading" @click="alipayApprove()">已了解，进行授权</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
const defaultFormData = {
    address: ''
};
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, String],
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            formData: { ...defaultFormData },
            rules: {
                address: [{ required: true, message: '请填写支付账号' }]
            }
        };
    },
    methods: {
        onCancel() {
            this.$emit('update:visible', false);
        },
        async alipayApprove() {
            this.loading = true;
            const response = await this.$request({
                url: '/certverify/alipay/preconsult',
                method: 'POST',
                formData: false,
                data: { redirectUri: window.location.pathname, logonId: this.formData.address }
            });
            const { state, result, msg } = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '认证失败，请稍后尝试');
            window.location.href = result;
        },
        save() {
            this.$refs['formData'].validate(async valid => {
                if (!valid) return;
                this.$emit('change-success');
                const response = await this.$request({
                    url: '/receiving/account/save',
                    method: 'post',
                    formData: false,
                    data: { accountType: 1, address: this.formData.address, cpId: this.$store.state.userInfo.id, id: this.id }
                });
                const { state, result, msg } = response.data;
                this.$emit('save-success');
                if (!state) return this.$message.error(msg || '认证失败，请稍后尝试');
                if (!result) return this.$message.error('认证失败，请确保您填写的支付宝账号为签约人持有，并通过了实名认证，前往修改支付账号');
                this.$message.success('恭喜，认证成功，您可以使用该支付宝收取来自秀动发行的收益');
                this.$emit('update:visible', false);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.describe {
    text-align: center;
    margin-bottom: 30px;

    b {
        color: $-text-950;
    }
}
</style>
